// material
import { styled } from '@mui/material/styles';
import {
  Card,
  // Alert,
  Container,
  Stack,
  Typography
} from '@mui/material';
// layouts
import AuthLayout from '../../layouts/AuthLayout';
// components
import Page from '../../components/Page';
import { MHidden } from '../../components/@material-extend';
import { LoginForm } from '../../components/authentication/login';
import Logo from 'src/components/Logo';
import { APP_INFO } from 'src/config';

// ----------------------------------------------------------------------

export const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 250,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2)
}));

export const ContentStyle = styled(Card)(({ theme }) => ({
  maxWidth: 480,
  minHeight: '650px',
  margin: 'auto',
  display: 'flex',
  maxHeight: '90vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(5, 3)
}));

const ContainerStyle = styled(Container)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '90vh'
}));

// ----------------------------------------------------------------------

export default function Login() {
  return (
    <RootStyle title="Login">
      <AuthLayout></AuthLayout>

      <MHidden width="mdDown">
        <SectionStyle></SectionStyle>
      </MHidden>

      <Container maxWidth="sm">
        <ContainerStyle>
          <ContentStyle sx={{ minWidth: '480px' }}>
            <Stack mb={2} width={1} justifyContent="center" alignItems="center">
              <Logo
                sx={{ width: 210, aspectRatio: 3 / 2, objectFit: 'cover', mixBlendMode: 'color-burn' }}
                defaultSrc="https://firebasestorage.googleapis.com/v0/b/faiej-1a04c.appspot.com/o/light.png?alt=media&token=a3eac0c2-60cc-4fa5-b1b4-6773a385c89d"
              />
            </Stack>
            <Stack mb={5} alignItems="center">
              <Typography variant="h4">Accédez à votre espace de travail </Typography>
              <Typography variant="h4">connecté</Typography>
              <Typography variant="caption">Identifiez-vous pour démarrer</Typography>
            </Stack>
            <LoginForm />
          </ContentStyle>
        </ContainerStyle>
      </Container>
    </RootStyle>
  );
}
